// Порт ref SubBlockSettingsEditor:447-482 — счётчик символов, выравнивание, размер L/XL.
import { Label } from '@teach/ui'
import type { DesignHeading } from '@/types/blocks'
import { DESIGN_LIMITS } from '@/features/editor/lib/designElements'
import { useContentLang } from '@/features/editor/hooks/useContentLang'
import { getLocalizedField } from '@/features/editor/lib/localizedField'
import { CharacterCounter, type CounterTone } from './CharacterCounter'
import { SegmentedRow } from './SegmentedRow'
import { ALIGN_OPTIONS } from './segmented'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  element: DesignHeading
  onUpdate: (patch: Partial<DesignHeading>) => void
}

const SIZES = [
  { value: 'large' as const, label: 'L' },
  { value: 'xlarge' as const, label: 'XL' },
]

const headingTone = (left: number): CounterTone =>
  left <= 5 ? 'destructive' : left <= 15 ? 'warning' : 'primary'

export const HeadingSettings = ({ element, onUpdate }: Props) => {
  const m = useMessages(messages)
  const contentLang = useContentLang()
  const used = (getLocalizedField(element, 'content', contentLang) ?? '').length
  const tone = headingTone(DESIGN_LIMITS.HEADING - used)

  return (
    <div className="space-y-4">
      <CharacterCounter used={used} limit={DESIGN_LIMITS.HEADING} tone={tone} />

      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{m.align}</Label>
        <SegmentedRow
          options={ALIGN_OPTIONS}
          value={element.textAlign}
          onSelect={(textAlign) => onUpdate({ textAlign })}
        />
      </div>

      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{m.textSize}</Label>
        <SegmentedRow
          options={SIZES}
          value={element.textSize}
          onSelect={(textSize) => onUpdate({ textSize })}
          dense
        />
      </div>
    </div>
  )
}
